export default __webpack_public_path__ + "static/media/Ahkio-Bold.93e13b5c.woff";